
import * as React from "react";
import classNames from "classnames";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { Droppable } from '../react-beautiful-dnd';
import { TagCard } from './TagCard'
import { Trade } from "../../models/Trade";
import { ColumnType } from "./Column";
import { Tag } from "../../models/Tag";
import { PhaseTag } from "../../models/PhaseTag";
import { ContextMenuTrigger } from "react-contextmenu";
import { ThunkDispatch } from "redux-thunk";
import { compose } from "redux";
import { connect } from 'react-redux';
import { getTradeColorByTags, TagRecord } from "../../selectors/lookahead.selector";
import { TagType } from "../../models/ TagType";

const _ = require('lodash')

interface BacklogProps {
    type: ColumnType;
    classes: ClassNameMap;
    tagRecords: TagRecord[];
    isDisabled: boolean;
    draggedTag: string | null;
    trades: Record<string, Trade>;
    backlogKey: string;
    isFullScreen: boolean;
    isAdmin: boolean;
	userTrades: Set<string>;
}

interface ColumnInnerProps { 
    type: ColumnType;
    tags?: Tag[];
    isDisabled: boolean;
    draggedTag: string | null;
    classes: ClassNameMap;
    trades: Record<string, Trade>;
    backlogKey: string;
    tradeColorByTags: Record<string, string>;
    tagRecords: TagRecord[];
    userTrades: Set<string>;
    isAdmin: boolean
}

const _InnerList = React.memo<ColumnInnerProps>( 
    ({tagRecords, draggedTag, classes,  trades, isDisabled, type, backlogKey, tradeColorByTags, isAdmin, userTrades }) => {

        const getTradeName = (tradeId:string):string => {
            const trade = trades[tradeId]
            if(!trade) {
                return ""
            }

            return trade.name as string
        }

        const attributes = {
            'className': classes.PhasePlanColumn
        }


        const getTradeColor = (tagId:string, tradeId: string):string => {
            const trade = !!trades[tradeId] ? trades[tradeId].color : tradeColorByTags[tagId]
            if(!trade) {
                return '#4286dd'
            }
            return trade
        }

        const getSortedTags = () => {
            if(!tagRecords) {
                return []
            }
            if(type === ColumnType.PhasePlan) {
                const phaseTags = tagRecords as PhaseTag[]
                return phaseTags.sort((a,b) =>  {
                    if(!a || !a.uid) return -1
                    if(!b || !b.uid) return 1

                    return a.uid.localeCompare(b.uid)
                    
                })
            } 

            if(type === ColumnType.Lookahead)  {
                return tagRecords.sort((a,b) => a.uid.localeCompare(b.uid))
            }


            return []
        }

       

        const renderTags = () => {

            if(!tagRecords) {
                return
            }

            
            return getSortedTags().map((tagRecord, index) => (
                <TagCard
                    userTrades={userTrades}
                    isAdmin={isAdmin}
                    isDisabled={isDisabled}
                    type={type}
                    key={tagRecord.uid} 
                    draggedTag={draggedTag} 
                    classes={classes} 
                    uid={tagRecord.uid}
                    index={index}
                    tradeName={getTradeName(tagRecord.tradeId)}
                    tradeColor={getTradeColor(tagRecord.uid, tagRecord.tradeId)}
                />))
        }

        return (
            <React.Fragment>
                {renderTags()}
                <ContextMenuTrigger
                    holdToDisplay={-1}
                    disable={isDisabled}
                    className={classNames(classes.PhasePlanColumnTrigger)}
                    attributes={attributes} 
                    id="column_context_menu"
                    style={{height: '100%'}}
                />
            </React.Fragment>
        
        )
})

const mapStateToProps = (state:any, ownProps?: any) => ({
    tradeColorByTags: getTradeColorByTags(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
    }
};

export const InnerList =  compose(
    connect(mapStateToProps, mapDispatchToProps),
  )(_InnerList);



export class Backlog extends React.Component<BacklogProps> {

    shouldComponentUpdate(nextProps :BacklogProps) {
        if(!_.isEqual(this.props.trades, nextProps.trades)) {
            return true
        }

        if(!_.isEqual(this.props.tags, nextProps.tags)) {
            return true
        }

        if(!_.isEqual(this.props.tagRecords, nextProps.tagRecords)) {
            return true
        }

        if(!_.isEqual(this.props.draggedTag, nextProps.draggedTag)) {
            return true
        }

        if(!_.isEqual(this.props.isDisabled, nextProps.isDisabled)) {
            return true
        }

        return false
    }

    renderDroppableProvider = (provided) => {
        const { classes, isDisabled, draggedTag, trades, tagRecords, type, userTrades, isAdmin } = this.props
        return (
            <div    						
                className={classNames(classes.PhasePlanTagList)} 
                ref={provided.innerRef}
                {...provided.droppableProps}
            >
                <InnerList
                    type={type}
                    isDisabled={isDisabled}
                    classes={classes}
                    draggedTag={draggedTag}
                    trades={trades} 
                    tagRecords={tagRecords}
                    userTrades={userTrades}
					isAdmin={isAdmin}
                />
                
            </div>
        )
    }

    render() {
        const { backlogKey } = this.props
        return (
            <Droppable 
                direction="horizontal" 
                droppableId={backlogKey}
                isDropDisabled={false}
            >
                {(provided: any) => this.renderDroppableProvider(provided)}
            </Droppable>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PhasePlan/Backlog.tsx